import { useEffect } from 'react';
import { convexTeamsStore } from '~/lib/stores/convexTeams';
import { waitForConvexSessionId } from '~/lib/stores/sessionId';
import { setSelectedTeamSlug } from '~/lib/stores/convexTeams';
import { useConvex } from 'convex/react';

const SELF_HOSTED_TEAM = {
  id: 'self-hosted',
  name: 'Self-Hosted',
  slug: 'self-hosted',
  referralCode: '',
};

export function useTeamsInitializer() {
  const convex = useConvex();
  useEffect(() => {
    void initSelfHostedTeam();
  }, [convex]);
}

async function initSelfHostedTeam() {
  await waitForConvexSessionId('fetchTeams');
  convexTeamsStore.set([SELF_HOSTED_TEAM]);
  setSelectedTeamSlug('self-hosted');
}
